import { doc, getDoc } from 'firebase/firestore';
import { collection } from 'firebase/firestore';
import { firestore } from '@src/api/Firebase/Firebase';

// ============================================================================
// EL RITMO DIARIO DE CADA INSUMO POR SUCURSAL — `inventory-usage/{sucursal}`
// (plan de inventario F4). Lo escribe SOLO el aseo diario del server (tarea 3d,
// `krispis-server/src/api/Cron/InventoryUsage.ts`) promediando los últimos 14 días
// cerrados de `daily-consumption`. Aquí solo se lee: UN documento por sucursal, una
// lectura por carga de la pantalla de inventario.
// ============================================================================

export interface InventoryUsage {
    branchOfficeId: string;
    /** Los días que se miraron (14). */
    days: number;
    /** Cuántos de esos días la sucursal vendió. Con menos de 3 el ritmo no se usa. */
    daysWithSales: number;
    /** Unidades base por día, por insumo. */
    perDay: Record<string, number>;
    units?: Record<string, { name: string; unit: string }>;
    schemaVersion: number;
    updatedAt?: any;
}

export const INVENTORY_USAGE_COLLECTION = 'inventory-usage';
export const inventoryUsageRef = collection(firestore, INVENTORY_USAGE_COLLECTION);

export default {
    /** El ritmo de la sucursal, o `undefined` si el aseo todavía no lo escribió. 1 lectura. */
    async getUsage(branchOfficeId: string): Promise<InventoryUsage | undefined> {
        const snapshot = await getDoc(doc(inventoryUsageRef, branchOfficeId));
        return snapshot.exists() ? (snapshot.data() as InventoryUsage) : undefined;
    }
};
